import { Link } from "@tanstack/react-router";
import { ChangeChannelCode } from "./change-channel-code";

export const AppHeader = () => {
  return (
    <header className="ekv:w-full ekv:bg-white ekv:shadow ekv:px-4 ekv:py-2 ekv:mb-4 ekv:flex ekv:items-center ekv:justify-between">
      <div className="ekv:flex ekv:flex-1 ekv:gap-2 ekv:p-2 ekv:items-center ekv:justify-center">
        <Link
          to="/"
          className="ekv:[&.active]:font-bold ekv:px-3 ekv:py-1 ekv:rounded ekv:hover:ekv:bg-gray-100"
        >
          Activities
        </Link>
        <Link
          to="/packages"
          className="ekv:[&.active]:font-bold ekv:px-3 ekv:py-1 ekv:rounded ekv:hover:ekv:bg-gray-100"
        >
          Packages
        </Link>
      </div>
      <ChangeChannelCode />
    </header>
  );
};
